export default __webpack_public_path__ + "static/media/banner-1.94dd9976.gif";